import styled from 'styled-components';
import { blue } from '../../assets/colors';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid rgb(239, 242, 244);
  background-color: rgb(255, 255, 255);
  padding: 20px 10px 20px 10px;
`;

export const Refresh = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  color: ${blue};
  & > svg {
    cursor: pointer;
  }
`;

export const Tools = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0px 10px 0px 10px;
`;

export const List = styled.div`
  min-height: 392px;
`;

// Shared components between completed and upcoming rows.
export const Tooltip = styled.div<{ $display: boolean }>`
  visibility: ${props => (props.$display ? 'visible' : 'hidden')};
  position: absolute;
  color: white;
  right: 35px;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  z-index: 10;
  background: rgba(24, 30, 36, 0.95);
  border-radius: 12px;
  padding: 8px 12px;
  font-size: 14px;
`;

export const BadgeTooltip = styled(Tooltip)`
  width: 350px;
  right: 270px;
  top: 5px;
  z-index: 100;
`;

export const BaseDiv = styled.div<{ $isHeader?: boolean }>`
  font-style: normal;
  font-weight: ${props => (props.$isHeader ? 700 : 400)};
  font-size: ${props => (props.$isHeader ? '12px' : '17px')};
  color: ${props => (props.$isHeader ? '#a3acb5' : '#181E24')};
  line-height: ${props => (props.$isHeader ? '16px' : '28px')};
  text-transform: ${props => (props.$isHeader ? 'uppercase' : '')};
  letter-spacing: ${props => (props.$isHeader ? '0.12em' : '')};
  border-bottom: ${props => (props.$isHeader ? '' : '1px solid #EFF2F4')};
  padding-top: 10px;
  padding-bottom: 10px;
`;

export const Date = styled(BaseDiv)`
  width: 200px;
  padding-left: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Time = styled(BaseDiv)`
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Children = styled(BaseDiv)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 60px;

  :hover {
    background-color: transparent;
  }
`;

export const NoRecapMessage = styled.div`
  font-weight: 500;
  font-size: 18px;
  line-height: 32px;
  text-transform: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #717982;
`;

export const Mail = styled.a`
  text-decoration: none;
  color: #ff6c54;
`;

export const Kickstart = styled.a`
  text-decoration: none;
  color: #0675fc;
  cursor: pointer;
`;

export const OneLine = styled.div`
  display: flex;
  gap: 5px;
`;

export const LoadingWrapper = styled.div`
  margin: 8rem 0 0 0;
`;

export const MenuItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;

  .options-menu {
    display: none;
  }

  &:hover {
    .options-menu {
      display: block;
    }
  }
`;
